<template>
    <span>
        <comunicadoslistagem></comunicadoslistagem>
    </span>
</template>

<script>
import Comunicadoslistagem from '@/components/Comunicados-Listagem';

export default {
    name: 'cadcomunicadoslistagem',
    components: {
        Comunicadoslistagem
    }
};
</script>